import { isContentFragment } from './content-fragment';
export function isFeatureApp(item) {
    return (isContentFragment(item) &&
        Boolean(item.model?.metadata) &&
        item.model?.metadata?.src !== undefined &&
        item.model?.metadata?.id !== undefined);
}
//# sourceMappingURL=feature-app.js.map